import { useLayoutEffect } from "react";
import { DspX1DSWebLegacyThemeUsage } from "@x1-theme/DspX1DSWebLegacyThemeUsage";
import { X1StyleXDarkTheme } from "@x1-theme/X1StyleXDarkTheme";
import { X1StyleXDefaultTheme } from "@x1-theme/X1StyleXDefaultTheme";

const COLOR_SCHEME_META_NAME = "color-scheme";
const THEME_COLOR_META_NAME = "theme-color";
const NAV_BAR_BACKGROUND = "nav-bar-background";

function useX1SetDarkModeMetaContent(isDarkMode) {
  useLayoutEffect(() => {
    setDarkModeMetaContent(isDarkMode);
  }, [isDarkMode]);
}

function setDarkModeMetaContent(isDarkMode) {
  setDarkModeMetaColorScheme(isDarkMode);
  const theme = isDarkMode ? X1StyleXDarkTheme : X1StyleXDefaultTheme;
  Object.assign(
    theme,
    isDarkMode
      ? DspX1DSWebLegacyThemeUsage.dark
      : DspX1DSWebLegacyThemeUsage.light,
  );
  setMetaThemeColor(theme[NAV_BAR_BACKGROUND]);
}

function setDarkModeMetaColorScheme(isDarkMode) {
  const content = isDarkMode ? "dark" : "light";
  let metaTag = document.querySelector(
    `meta[name="${COLOR_SCHEME_META_NAME}"]`,
  );

  if (!metaTag) {
    metaTag = document.createElement("meta");
    metaTag.setAttribute("name", COLOR_SCHEME_META_NAME);
    metaTag.setAttribute("content", content);
    document.querySelector("head")?.appendChild(metaTag);
  } else {
    metaTag.setAttribute("content", content);
  }
}

function setMetaThemeColor(color) {
  let metaTag = document.querySelector(`meta[name="${THEME_COLOR_META_NAME}"]`);

  if (!metaTag) {
    metaTag = document.createElement("meta");
    metaTag.setAttribute("name", THEME_COLOR_META_NAME);
    metaTag.setAttribute("content", color);
    document.querySelector("head")?.appendChild(metaTag);
  } else {
    metaTag.setAttribute("content", color);
  }
}

export const UseX1SetDarkModeMetaContent = {
  useX1SetDarkModeMetaContent,
};
